interface Customerish {
  firstname?: string
  lastname?: string
  givenName?: string
  familyName?: string
  firstName?: string
  lastName?: string
  salutation?: string
}

const noName = '--'

const customerToDisplayName = (customer?: Customerish): string => {
  if (!customer) {
    return noName
  }

  const { firstname, lastname, givenName = firstname, familyName = lastname, salutation } = customer

  if ([givenName, familyName].every((name) => !name)) {
    return noName
  }

  if (salutation) {
    return `${familyName || noName}, ${givenName || noName} (${salutation})`
  }

  return `${familyName || noName}, ${givenName || noName}`
}

export { customerToDisplayName }
